<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="row">
            <div class="col-xs-12 col-sm-4">
              <div class="form-group">
                <label class="custom-font">Mês de Referência</label>
                <div class="custom-select">
                  <v-select v-model="referencia" @input="loadEscalas" :options="referencias"
                    :reduce="option => option.value" :selectOnTab="true" />
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div class="form-group">
                <label class="custom-font">Pesquisar por palavras</label>
                <div class="inputgroupcontainer">
                  <div class="input-group">
                    <input v-model="termoPesquisa" @keypress.enter="pesquisar" class="form-control input-custom" type="text" />
                    <a href="#" class="input-group-addon" @click="pesquisar">
                      <font-awesome-icon :icon="'search'" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12">
          <data-table 
            ref="escalas" 
            :has-auth="false" 
            :api-mode="false" 
            :dados="escalas"
            :show-empty="true"
            :carregando="carregandoDados" 
            :fields="datatable.columns">

            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button title="Remover publicação" class="btn btn-danger" @click="removerPublicacao(props.rowData)">
                  <font-awesome-icon :icon="'file-download'"></font-awesome-icon>
                </button>
              </div>
            </template>

          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from '@/request'
import DataTable from '@/components/common/NoApiTable'

export default {
  components: {
    DataTable
  },
  inject: ["showConfirm"],
  data() {
    return {
      title: 'Remover publicação',
      escalaId: null,
      referencia: null,
      escalas: [],
      escalas_original: [],
      referencias: [],
      termoPesquisa: '',
      carregandoDados: false,
      datatable: {
        columnID: 'id',
        columns: [
          {
            name: 'uor_sigla',
            title: 'Unidade',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'nome',
            title: 'Criado por',
            dataClass: 'align-middle',
            filterable: true
          },
          {
            name: 'publicado_em',
            title: 'Publicado em',
            dataClass: 'align-middle',
            callback: value => {
              return new Date(value).toLocaleString().replace(',', '')
            }
          },
          {
            name: '__slot:actions',
            title: 'Ações',
            titleClass: 'text-center col-md-1',
            dataClass: 'text-center align-middle'
          }
        ]
      }
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadReferencias()
    this.setReferencia()
  },
  computed: {
    colaboradores() {
      return this.$store.state.escala.funcionarios
    },
  },
  watch: {
    referencia(value) {
      if (value) this.loadEscalas()
    }
  },
  methods: {
    loadReferencias() {
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth()

      if (currentMonth == 11) {
        const nextYear = currentYear + 1
        let date = new Date(currentYear, currentMonth, 1, 1)
        let month = date.toLocaleDateString('pt-BR', { month: '2-digit' })

        let label = date.toLocaleDateString('pt-BR', {
          month: 'long',
          year: 'numeric'
        }).toLocaleUpperCase()
        let value = `${date.getFullYear()}${month}`

        this.referencias.push({
          label,
          value
        })

        for (let index = 0; index < 5; index++) {
          date = new Date(nextYear, index, 1, 1)
          month = date.toLocaleDateString('pt-BR', { month: '2-digit' })

          label = date.toLocaleDateString('pt-BR', {
            month: 'long',
            year: 'numeric'
          }).toLocaleUpperCase()
          value = `${date.getFullYear()}${month}`

          this.referencias.push({
            label,
            value
          })
        }
      } else {
        for (let index = currentMonth; index < 12; index++) {
          const date = new Date(currentYear, index, 1, 1)
          const month = date.toLocaleDateString('pt-BR', { month: '2-digit' })

          const label = date.toLocaleDateString('pt-BR', {
            month: 'long',
            year: 'numeric'
          }).toLocaleUpperCase()
          const value = `${date.getFullYear()}${month}`

          this.referencias.push({
            label,
            value
          })
        }
      }
    },
    loadEscalas() {
      const { referencia, adicionarDadosDeColaboradorNasEscalas, toogleCarregandoDados } = this

      toogleCarregandoDados()

      request
        .get(`escala/listar-publicadas?referencia=${referencia}`)
        .then(({ data }) => {
          this.escalas = adicionarDadosDeColaboradorNasEscalas(data)
          this.escalas_original = [...this.escalas]
        })
        .catch(e => {
          console.log(e)
        }).finally(toogleCarregandoDados);
    },
    setReferencia() {
      const currentDate = new Date()
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        1,
        1
      )
      const month = date.toLocaleDateString('pt-BR', {
        month: '2-digit'
      })
      this.referencia = `${date.getFullYear()}${month}`
    },
    adicionarDadosDeColaboradorNasEscalas(lista) {
      return lista.map(item => {
        const colaborador = this.colaboradores.find(({ sshd }) => sshd.toLocaleUpperCase() == item.user_sshd.toLocaleUpperCase())
        const { nome, cargo } = colaborador

        return { nome, cargo, ...item }
      })
    },
    pesquisar() {
      this.escalas = this.escalas_original.filter(({ uor_sigla, nome, publicado_em }) => {
        const sigla = uor_sigla.toUpperCase()
        const nome_usuario = nome.toUpperCase()
        const termo = this.termoPesquisa.toUpperCase()

        return sigla.indexOf(termo) > -1 
        || nome_usuario.indexOf(termo) > -1 
        || publicado_em.indexOf(termo) > -1
      })
    },
    toogleCarregandoDados() {
      this.carregandoDados = !this.carregandoDados
    },
    removerPublicacao({ id }) {
      var config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.post('escala/despublicar', { id })
          .then(() => this.removerItemEscala(id))
          .catch(error => {
            console.log(error)
            this.$toastr.e('Houve uma falha ao tentar remover a publicação da escala, Tente novamente daqui alguns minutos!')
          })
        }
      }
      this.showConfirm('Deseja realmente remover a publicação desta escala?', config)
    },
    removerItemEscala(id) {
      this.escalas = this.escalas_original.filter(item => item.id != id)
      this.escalas_original = [...this.escalas]
    }
  }
}
</script>
  
<style scoped="">
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.input-group {
  border: 1px solid #00615c !important;
  border-radius: 4px;
}

.input-custom {
  border: 2px solid #468b35  !important;
  padding: 3px 10px !important;
  height: 36px;
}

.input-group-addon {
  background-color: transparent;
  border: 2px solid #468b35;
  border-left: 0px solid #00615c;
  color: #00615c;;
}

.input-group-addon:hover {
  color: white;
  background-color: #a1be4d;
}
</style>
  
<style>
.text-center {
  text-align: center;
}

.vs__dropdown-toggle {
  border: 2px solid #468b35 !important;
  padding: 3px 10px !important;
}

.vs__search {
  font-size: 12px !important;
  text-transform: uppercase;
}
</style>
  


// WEBPACK FOOTER //
// src/views/admin/escalas/RemoverPublicacao.vue